import {
  MultiDropdownBase,
  MultiDropdownItemLabel,
  type MultiDropdownOption,
  type MultiDropdownProps,
} from "#components/shared/MultiDropdownBase";
import { SwitchIndicator } from "#components/Switch";

export type MultiToggleDropdownOption = MultiDropdownOption;

export type MultiToggleDropdownProps = MultiDropdownProps;

export function MultiToggleDropdown(props: MultiToggleDropdownProps) {
  return (
    <MultiDropdownBase
      {...props}
      renderItem={(item, isSelected, isHovered, isFocused) => (
        <div className="flex items-center gap-md">
          <SwitchIndicator isFocused={isFocused} isHovered={isHovered} isSelected={isSelected} />
          <MultiDropdownItemLabel item={item} />
        </div>
      )}
    />
  );
}
